// =====================================================
// Swiss Finance OS - Login Page
// Authentication entry point
// =====================================================

import { LoginForm } from '@/components/auth/LoginForm';

export default function Login() {
  return <LoginForm />;
}